import React, { useMemo } from 'react';
import { arrayOf, node, string } from 'prop-types';
import GuestyPayContext from "../../contexts/guestyPayContext";
import initialize from "../../guestyTokenization/initialize";
var GuestyPayProvider = function GuestyPayProvider(_ref) {
  var _ref$env = _ref.env,
    env = _ref$env === void 0 ? 'production' : _ref$env,
    children = _ref.children;
  var guestyTokenization = useMemo(function () {
    return initialize(env);
  }, [env]);
  return /*#__PURE__*/React.createElement(GuestyPayContext.Provider, {
    value: guestyTokenization,
    "data-qa": "guesty-pay-provider"
  }, children);
};
GuestyPayProvider.propTypes = {
  /** GuestyPayWidget and submit button to be rendered in children tree */
  children: node.isRequired || arrayOf(node).isRequired,
  /** Environment. Options: [stagingX | preprod | production] */
  env: string
};
export default GuestyPayProvider;